/* @ngInject */
function ReadersCoreController ($scope, $state, $rootScope, $q, $timeout, $window, PostsService, ToastService, $translate, Utils, SliderService, EmojisService, SegmentService) {
  $scope.flagsReadersCore = {
    bLoadingInsideViewers: false,
    seeReaders: false,
    activeReadersTab: 'all'
  }

  $scope.reactionBarConfig = {
    hideBackground: true,
    readers: true,
    noEvents: true
  }
  $scope.emojis = []
  $scope.usersRead = []

  function hideComments (el) {
    el.fadeTo(500, 0)

    $timeout(() => {
      el.css('display', 'none')
      $scope.flagsReadersCore.seeReaders = false
      $scope.flags.seeReaders = false
    }, 500, false)
  }

  $scope.closeReaders = function () {
    if ($rootScope.isDesktop) {
      const el = jQuery('.post-views')
      hideComments(el)
    } else {
      SliderService.setState('post-slider', 'close')
      SliderService.setState('readers-slider', 'open', {
        postId: $scope.post.id,
        title: $scope.post.title
      })
    }
  }

  $scope.generateReadGraphics = function () {
    const getReadProgress = (totalUsers, usersWhoRead) => Math.round((usersWhoRead / totalUsers) * 100) || 0
    const getEmailOpenProgress = (totalUsers, usersOpenEmail) => Math.round((usersOpenEmail / totalUsers) * 100) || 0

    const totalUsers = $scope.usersRead.length
    const usersWhoRead = $scope.usersRead.filter(user => user.isRead).length
    const usersOpenEmail = $scope.usersRead.filter(user => user.emailOpenDate).length
    $scope.readGraphics = []

    const progressEmailOpened = getEmailOpenProgress(totalUsers, usersOpenEmail)
    const progressWhoRead = getReadProgress(totalUsers, usersWhoRead)

    $scope.readGraphics.push({
      class: Utils.getClassForProgress(progressEmailOpened),
      progress: progressEmailOpened,
      icon: 'mail',
      tooltipText: $translate.instant('mailsOpened'),
      usersTooltipText: `${usersOpenEmail} ${$translate.instant('users')}`
    })

    $scope.readGraphics.push({
      class: Utils.getClassForProgress(progressWhoRead),
      progress: progressWhoRead,
      icon: 'eye',
      tooltipText: $translate.instant('read'),
      usersTooltipText: `${usersWhoRead} ${$translate.instant('users')}`
    })
  }

  $scope.generateReactionData = function () {
    const totalUsers = $scope.usersRead.filter(userRead => userRead.userReaction).length
    const reactions = $scope.reactions.reduce((obj, item) => {
      obj[item.name.toLowerCase()] = item

      return obj
    }, {})

    const usersReactedGrinning = $scope.usersRead.filter(user => user.userReaction && user.userReaction === reactions.grinning.code).length
    const percentageReactedGrinning = Math.round((usersReactedGrinning / totalUsers) * 100)

    const usersReactedNeutral = $scope.usersRead.filter(user => user.userReaction && user.userReaction === reactions.neutral.code).length
    const percentageReactedNeutral = Math.round((usersReactedNeutral / totalUsers) * 100)

    const usersReactedDisappointed = $scope.usersRead.filter(user => user.userReaction && user.userReaction === reactions.disappointed.code).length
    const percentageReactedDisappointed = Math.round((usersReactedDisappointed / totalUsers) * 100)

    $scope.reactionsData = [
      {
        disappointed: percentageReactedDisappointed || 0,
        users: usersReactedDisappointed
      },
      {
        neutral: percentageReactedNeutral || 0,
        users: usersReactedNeutral
      },
      {
        grinning: percentageReactedGrinning || 0,
        users: usersReactedGrinning
      }
    ]

    if (!$scope.$$phase) {
      $scope.$apply()
    }
  }

  $scope.getClassForProgress = function (progress) {
    if (progress >= 60) {
      return 'progress-green'
    } else if (progress > 30 && progress < 60) {
      return 'progress-yellow'
    } else {
      return 'progress-red'
    }
  }

  $scope.changeActiveTab = function (tab) {
    $scope.flagsReadersCore.activeReadersTab = tab
    switch (tab) {
      case 'all':
        $scope.filterViewed = {}
        break
      case 'read':
        $scope.filterViewed = { isRead: true }
        break
      case 'unread':
        $scope.filterViewed = { isRead: false }
        break
    }
  }

  $scope.onLastRepeatViewers = function () {
    jQuery('.dropdown-post-viewers-list').dropdown({
      showOnFocus: false
    })
  }

  $scope.resendMailNotification = function (oUser) {
    $scope.flagsReadersCore.bLoadingInsideViewers = true
    PostsService.resendPostEmail($scope._postId, oUser.id)
      .then(function () {
        $scope.flagsReadersCore.bLoadingInsideViewers = false
        ToastService.defaultSuccessToast()
      })
      .catch(function () {
        $scope.flagsReadersCore.bLoadingInsideViewers = false
        ToastService.defaultErrorToast()
      })
  }

  $scope.getClassForEmailIcon = function (oData) {
    var sClass = ''

    if (oData.emailBounceDate || oData.emailRejectDate) {
      sClass = 'red'
    } else if (oData.emailOpenDate) {
      sClass = 'green open'
    }

    return sClass
  }

  $scope.getEmailIconTooltipText = function (oData) {
    if (oData.emailBounceDate) {
      return $scope.formatDateTooltipText('mailErrorAt', oData.emailBounceDate)
    } else if (oData.emailRejectDate) {
      return $scope.formatDateTooltipText('mailErrorAt', oData.emailRejectDate)
    } else if (oData.emailOpenDate) {
      return $scope.formatDateTooltipText('mailOpenedAt', oData.emailOpenDate)
    } else if (oData.emailDeliveryDate) {
      return $scope.formatDateTooltipText('mailDeliveredAt', oData.emailDeliveryDate)
    } else if (oData.emailSendDate) {
      return $scope.formatDateTooltipText('mailSendAt', oData.emailSendDate)
    }

    return $translate.instant('mailNotSent')
  }

  $scope.formatDateTooltipText = function (sTranslateKey, dDate) {
    return Utils.formatDateTooltipText(sTranslateKey, dDate)
  }

  $scope.getPostReaders = function (postId) {
    SegmentService.track('open-announcement-statistics', { post_id: postId })
    $scope.flagsReadersCore.bLoadingInsideViewers = true

    const emojis = EmojisService.getEmojis([
      'DISAPPOINTED',
      'NEUTRAL',
      'GRINNING'
    ])

    const postReaders = PostsService.getUsersWithReadFlag(postId)

    $q.all([emojis, postReaders])
      .then(([emojis, postReaders]) => {
        const mappedUsers = postReaders.map(user => Object.assign(user, { isRead: !!user.readAt }))
        $scope.usersRead = Utils.mapPropertyToSafeValue(mappedUsers, 'userReaction')
        $scope.reactions = Utils.mapPropertyToSafeValue(emojis, 'code')
        $scope.generateReadGraphics()
        if ($scope.post.trackReactions) {
          $scope.generateReactionData()
        }
        $scope.flagsReadersCore.bLoadingInsideViewers = false
      })
      .catch(() => {
        $scope.closeReaders()
        ToastService.defaultErrorToast()
      })
  }

  $scope.openAnalyticsAnnouncements = () => {
    const state = 'analytics.dashboard'

    const params = {
      slug: 'announcements-overview'
    }

    const options = {
      absolute: true
    }

    const analyticsAnnouncementsURL = $state.href(state, params, options)

    SegmentService.track('announcement-preview-results-analytics-btn')

    if (window.clarity) {
      window.clarity('set', 'announcement-preview-results-analytics-btn', null)
    }

    $window.open(analyticsAnnouncementsURL, '_target')
  }
}

export { ReadersCoreController }
